import SEO from "@/components/SEO";
import { Btn } from "@/components/primitives";
import GrowthRing from "@/components/visuals/GrowthRing";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found | Green Circle Group"
        description="The page you were looking for could not be found."
        noindex
      />
      <section className="relative bg-white min-h-[80vh] flex items-center overflow-hidden py-28">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-60"
        >
          <GrowthRing size={520} duration={80} />
        </div>
        <div className="relative mx-auto max-w-xl px-5 sm:px-8 text-center">
          <p className="text-7xl md:text-8xl font-extrabold text-forest">404</p>
          <h1 className="mt-4 text-2xl md:text-3xl font-extrabold text-forest">
            This page has moved on to another job.
          </h1>
          <p className="mt-4 text-mid-neutral leading-relaxed">
            The page you were looking for could not be found. Let&apos;s get you back
            to something useful.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
            <Btn to="/" size="lg" data-testid="notfound-home-btn">
              Back to Home
            </Btn>
            <Btn to="/contact" variant="secondary" size="lg" withArrow>
              Book a Free Growth Assessment
            </Btn>
          </div>
        </div>
      </section>
    </>
  );
}
